module.exports = __webpack_public_path__ + "img/7.4ae85d63.jpg";